import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'template-dialog',
    templateUrl: 'template.dialog.html',
    styleUrls: ['./template.dialog.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateDialog {

    DialogData;

    constructor(private dialogRef: MatDialogRef<TemplateDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.DialogData = data;
        dialogRef.disableClose = true;
    }

    close() {
        this.dialogRef.close();
    }
}
